import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTOWorkspaceUserInvitation } from '@shared/dto/+workspace/workspace_user_invitation/dto_workspace_user_invitation';
import { STATE__workspace } from '../STATE__workspace';

interface PAYLOAD {
  invitations: DTOWorkspaceUserInvitation[];
  user_id: string;
}

export const local_workspace_user_invitation_upsert = (payload: PAYLOAD): PayloadAction<PAYLOAD> => ({
  type: ENUM__redux_action.WORKSPACE_USER_INVITATION_UPSERT,
  payload,
});

export function init_local_workspace_user_invitation_upsert(state: STATE__workspace, action: PayloadAction<PAYLOAD>) {
  const { user_id } = action.payload;

  for (let workspace_user_invitation of action.payload.invitations) {
    try_add_invitation_to_other_users(state, workspace_user_invitation, user_id);

    try_add_invitation_to_current_user(state, workspace_user_invitation, user_id);
  }
}

const try_add_invitation_to_other_users = (state: STATE__workspace, invitation: DTOWorkspaceUserInvitation, user_id: string) => {
  if (invitation.owner_user_id != user_id) return;

  state.invitations_map_to_other_users.set(invitation._id, invitation);

  //refresh map to trigger re-render
  state.invitations_map_to_other_users = new Map(state.invitations_map_to_other_users);
};

const try_add_invitation_to_current_user = (state: STATE__workspace, invitation: DTOWorkspaceUserInvitation, user_id: string) => {
  if (invitation.target_user_id != user_id) return;
  if (invitation.owner_user_id == user_id) return; //user was member and become owner

  state.invitations_map_to_other_workspaces.set(invitation._id, invitation);

  //need recreate array to trigger re-render
  state.invitations_map_to_other_workspaces = new Map(state.invitations_map_to_other_workspaces);
};
